import generateDirective from '../generator';
import AdditionalInformationController from './controller';

generateDirective('AdditionalInformation', '/customer_application_renderer/stages/additional_information/form.html', AdditionalInformationController);
